import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'salutation'
})
export class SalutationPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case 'MR':
        return 'M.';
      case 'MRS':
        return 'Mme';
      default:
        return '';
    }
  }
}
